'use client';
import { Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import colors from '@/theme/colors.module.scss';
import styles from './styles.module.scss';
import Typography from '@/components/shared/typography/typography.component';

export default function MobileTabs({
  lang,
  tab1Title,
  tab2Title,
}: {
  lang: 'ar' | 'en';
  tab1Title: string;
  tab2Title: string;
}) {
  let tabValueCheck = 0;
  const [value, setValue] = useState<number>(0);

  const handleScroll = () => {
    const whySylndrElement = document.getElementById('sylndr-certified');
    const howItWorksElement = document.getElementById('how-it-works');
    if (!whySylndrElement || !howItWorksElement) return;
    const { bottom: SCoffsetBottom, top: SCoffsetTop } = whySylndrElement.getBoundingClientRect();
    const { bottom: HIWoffsetBottom, top: HIToffsetTop } =
      howItWorksElement.getBoundingClientRect();

    const scrollPosition = window.scrollY;
    if (scrollPosition > SCoffsetTop && scrollPosition < SCoffsetBottom && tabValueCheck !== 0) {
      setValue(0);
      tabValueCheck = 0;
    }
    if (scrollPosition > HIToffsetTop && scrollPosition < HIWoffsetBottom && tabValueCheck !== 1) {
      setValue(1);
      tabValueCheck = 1;
    }
  };
  useEffect(() => {
    const urlHash = window.location.hash;
    if (urlHash.length) {
      const element = document.getElementById(urlHash.substring(1));
      if (element) {
        element.scrollIntoView();
      }
    }
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);

    const whySylndrElement = document.getElementById('sylndr-certified');
    const howItWorksElement = document.getElementById('how-it-works');
    if (!whySylndrElement || !howItWorksElement) return;

    if (newValue === 0) {
      const { top: SCoffsetTop } = whySylndrElement.getBoundingClientRect();
      window.scrollTo({
        top: SCoffsetTop - 60,
        left: 0,
        behavior: 'smooth',
      });
      tabValueCheck = 0;
    }
    if (newValue === 1) {
      const { top: HIToffsetTop } = howItWorksElement.getBoundingClientRect();
      window.scrollTo({
        top: HIToffsetTop - 60,
        left: 0,
        behavior: 'smooth',
      });
      tabValueCheck = 1;
    }
  };
  return (
    <div className={styles.container}>
      <Tabs
        style={{ borderBottom: `1px solid ${colors.gray200}` }}
        value={value}
        onChange={handleChange}
        centered
      >
        <Tab label={<Typography variant="body2Medium">{tab1Title}</Typography>} />
        <Tab label={<Typography variant="body2Medium">{tab2Title}</Typography>} />
      </Tabs>
    </div>
  );
}
